import type React from 'react';
import { useAuth } from 'react-oidc-context';

const AuthGuard = ({ children }: React.PropsWithChildren) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) return null;

  return children;
};
AuthGuard.displayName = 'AuthGuard';

export default AuthGuard;
